module.exports = __webpack_public_path__ + "static/recipe-collect-2-ebe74cea3ba49fd49c193ce1d2492380.jpg";